import React from 'react'
import { Input, InputNumber, Select, Button, AutoComplete } from 'element-react'

// Styles::
/* ++++++++++++++++++++++++++++++++++++
    These are styles for the mixed
    inputs w/ select menus.
+++++++++++++++++++++++++++++++++++*/
const selectStyle = {
    width: '100px',
}

const InputSG = () => {
    const inputNum = 1
    const restaurants = [
        { value: 'vue', address: 'https://github.com/vuejs/vue' },
        {
            value: 'element',
            address: 'https://github.com/ElemeFE/element',
        },
        {
            value: 'cooking',
            address: 'https://github.com/ElemeFE/cooking',
        },
        {
            value: 'mint-ui',
            address: 'https://github.com/ElemeFE/mint-ui',
        },
        { value: 'vuex', address: 'https://github.com/vuejs/vuex' },
        {
            value: 'vue-router',
            address: 'https://github.com/vuejs/vue-router',
        },
        { value: 'babel', address: 'https://github.com/babel/babel' },
    ]
    const value1 = ''

    // Query Search -- Autocomplete
    const querySearch = (queryString, cb) => {
        const results = queryString
            ? restaurants.filter(createFilter(queryString))
            : restaurants
        cb(results)
    }

    // Create Filter -- Autocomplete
    const createFilter = queryString => {
        return restaurant => {
            return (
                restaurant.value
                    .toLowerCase()
                    .indexOf(queryString.toLowerCase()) === 0
            )
        }
    }

    return (
        <div>
            {/* Basic Inputs ============================  */}
            <h4 className="sg-heading">Inputs</h4>
            <label>This is a label</label>
            <Input placeholder="Please input" className="margin-bottom-small" />
            <Input
                icon="time"
                placeholder="Pick a date"
                className="margin-bottom-small"
            />

            {/* Textarea ============================  */}
            <h4 className="sg-heading">Textarea</h4>
            <Input
                type="textarea"
                autosize={{ minRows: 2, maxRows: 4 }}
                placeholder="Please input"
            />

            {/* Input Number ============================  */}
            <h4 className="sg-heading">Input Number</h4>
            <InputNumber
                defaultValue={inputNum}
                min="1"
                max="10"
                className="margin-bottom-small"
            ></InputNumber>

            {/* Mixed Input ============================  */}
            <h4 className="sg-heading">Mixed Input</h4>
            <Input
                placeholder="Please input"
                prepend="Http://"
                className="margin-bottom-small"
            />
            <Input
                placeholder="Please input"
                append=".com"
                className="margin-bottom-small"
            />
            <Input
                placeholder="Please input"
                className="margin-bottom-small el-append-button"
                prepend={
                    <Select style={selectStyle} value="" placeholder="Select">
                        {['Restaurant', 'Order No.', 'Tel'].map(
                            (item, index) => (
                                <Select.Option
                                    key={index}
                                    label={item}
                                    value={index}
                                />
                            ),
                        )}
                    </Select>
                }
                append={
                    <Button type="primary" icon="search">
                        Search
                    </Button>
                }
            />

            {/* AutoComplete ============================  */}
            <h4 className="sg-heading">AutoComplete</h4>
            <AutoComplete
                placeholder="Please input"
                value={value1}
                fetchSuggestions={querySearch}
                onSelect={() => null}
            ></AutoComplete>
        </div>
    )
}

export default InputSG
